import LASingleLettersBreaker from "../plugins/PluginLASingleLettersBreaker";

new LASingleLettersBreaker({ autoInit: true })